import React, {Component} from 'react';
import './StartPaper.scss';
import *as paperServicess from '../../../../services/papers';
import * as constants from "../../../../const/constants";
import {Button, Col, Container, Row} from 'reactstrap';
import Timer from 'react-compound-timer'
import {lang, language} from "../../../../const/language";
import * as commonFunc from "../../../../utils/commonFunc";

import swal from "sweetalert";
import moment from "moment";

class StartPaper extends Component {
    state = {
        paper: undefined,
        mobileView: 0,
        toggleState: 0,
        remTime: '',
        noOfAnswersPerQuestion: "",
        newResult: new Array(0).fill().map((value, id) => (({
            id: id,
            answers: new Array(0).fill().map((value, id) => (({
                id: id,
                condition: false
            })))
        }))),
        finalResult: '',
        warningState: 0,
        numPages: null,
        pageNumber: 1,
        values: [5],
        randomLoad:0
    }

    checkResultSheet = async () => {
        const abc = localStorage.getItem("resultSheet" + this.state.paper.id)
        if (abc !== null && abc !== 'undefined') {
            const newRe = JSON.parse(abc);
            this.setState({
                newResult: newRe
            })
        } else {
            this.setAnswerSheet();
        }
    }

    answerChangeHandler = (questionquestionIndex, answerquestionIndex) => {
        let {newResult} = this.state;
        newResult[questionquestionIndex].answers[answerquestionIndex].condition = !newResult[questionquestionIndex].answers[answerquestionIndex].condition;

        this.setState({
            newResult: this.state.newResult
        })

        newResult.map((obj, questionIndex) => {
            obj.answers.map((ansObj, answerIndex) => {
                if (questionIndex === questionquestionIndex && answerIndex !== answerquestionIndex) {
                    newResult[questionIndex].answers[answerIndex].condition = false
                }
            })
        })
        this.generateResultString()
    }

    generateResultString = async () => {
        let {newResult} = this.state;
        localStorage.setItem("resultSheet" + this.state.paper.id, JSON.stringify(newResult))
        let finalResult = "";
        newResult.map((obj, questionIndex) => {

            let isMultiple = false;
            obj.answers.map((ansObj, answerIndex) => {
                if (ansObj.condition) {
                    finalResult = finalResult + (answerIndex + 1);
                }
            })
            finalResult = finalResult + ";";
        })
        const results = finalResult.length !== 0 ? finalResult.includes(";;") : true

        await this.setState({
            finalResult: finalResult,
            answerInComplete: results
        })
        localStorage.setItem("finalResult" + this.state.paper.id, this.state.finalResult)

        this.autoSubmitAnswers();
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        this.checkResultSheet();
        this.screeSizeChecking();
        this.autoSubmitAnswers();
    }

    autoSubmitAnswers = async () => {
        if (this.state.paper.flowType) {

            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "answers": localStorage.getItem("finalResult" + this.state.paper.id),
                "state": 1
            }
            await paperServicess.saveAnswers(data)
                .then(res => {
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }else{
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
                "answers": localStorage.getItem("finalResult" + this.state.paper.id),
                "state": 1
            }
            await paperServicess.saveCourseAnswers(data)
                .then(res => {
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })


        }
    };

    autoEndPaper = async () => {

        if (this.state.paper.flowType) {
            let ans = localStorage.getItem("finalResult" + this.state.paper.id);
            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "answers": ((ans === undefined || ans === null) || ans === 'undefined') ? '' : ans,
                "state": 3
            }
            await paperServicess.endAndSubmitQuize(data)
                .then(res => {
                    // console.log(res)
                    const score = res.body
                    const presentage = Number(score) * 100 / Number(this.state.paper.noOfQuestions)
                    localStorage.setItem("presentage", presentage)
                    localStorage.setItem("Marks", score)
                    localStorage.setItem("Quiz", this.state.paper.noOfQuestions)
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.FINISHED_PAPER_ROUTE}`);


                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }else {
            let ans = localStorage.getItem("finalResult" + this.state.paper.id);
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
                "answers": ((ans === undefined || ans === null) || ans === 'undefined') ? '' : ans,
                "state": 3
            }
            await paperServicess.endAndSubmitCourseQuiz(data)
                .then(res => {
                    // console.log(res)
                    const score = res.body;
                    const presentage = Number(score) * 100 / Number(this.state.paper.noOfQuestions)
                    localStorage.setItem("presentage", presentage)
                    localStorage.setItem("Marks", score)
                    localStorage.setItem("Quiz", this.state.paper.noOfQuestions)
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.FINISHED_PAPER_ROUTE}`);


                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })


        }
    }

    completePaper = async () => {
        if (this.state.paper.flowType) {
            let ans = localStorage.getItem("finalResult" + this.state.paper.id);
            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "answers": ((ans === undefined || ans === null) || ans === 'undefined') ? '' : ans,
                "state": 2
            }
            await paperServicess.endAndSubmitQuize(data)
                .then(res => {
                    console.log('asd', res)
                    const score = res.body
                    const percentage = Number(res.body) * 100 / Number(this.state.paper.noOfQuestions)
                    localStorage.setItem("resultSheet" + this.state.paper.id, undefined)
                    localStorage.setItem("finalResult" + this.state.paper.id, '')
                    localStorage.setItem("score", score)
                    localStorage.setItem("presentage", percentage)
                    localStorage.setItem("Marks", score)
                    localStorage.setItem("Quiz", this.state.paper.noOfQuestions)
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.FINISHED_PAPER_ROUTE}`);
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }
        else{
            let ans = localStorage.getItem("finalResult" + this.state.paper.id);
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
                "answers": ((ans === undefined || ans === null) || ans === 'undefined') ? '' : ans,
                "state": 2
            };
            await paperServicess.endAndSubmitCourseQuiz(data)
                .then(res => {
                    console.log('asd', res);
                    const score = res.body;
                    const percentage = Number(res.body) * 100 / Number(this.state.paper.noOfQuestions);
                    localStorage.setItem("resultSheet" + this.state.paper.id, undefined);
                    localStorage.setItem("finalResult" + this.state.paper.id, '');
                    localStorage.setItem("score", score);
                    localStorage.setItem("presentage", percentage);
                    localStorage.setItem("Marks", score);
                    localStorage.setItem("Quiz", this.state.paper.noOfQuestions);
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.FINISHED_PAPER_ROUTE}`);
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })


        }
    };

    submitPaper = async (paper) => {
        swal({
            title: constants.EXAM_ALERT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    this.completePaper();
                    break;
                default:
                    break;
            }
        });
    };

    setAnswerSheet = async (event) => {
        if (this.state.paper.noOfQuestions !== 0) {
            await this.setState({
                // [event.target.name]: event.target.value,
                newResult: new Array(Number(this.state.paper.noOfQuestions)).fill().map((value, id) => (({
                    id: id,
                    answers: new Array(Number(this.state.paper.noOfAnswersPerQuestion)).fill().map((value, id) => (({
                        id: id,
                        condition: false
                    })))
                })))
            });
        } else {
            await this.setState({
                [event.target.name]: event.target.value,
            });
        }
    };

    togglePaperAnswer = (e) => {
        this.setState({
            toggleState: e
        })
    }

    async UNSAFE_componentWillMount() {
        let state = this.props.location.state;
        if (state) {
            await this.setState({
                paper: state,
            })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`);
        }
    }

    screeSizeChecking = () => {
        if (window.innerWidth <= 991) {
            this.setState({
                mobileView: 1
            });
        } else {
            this.setState({
                mobileView: 0
            });
        }
    };

    reloadPaper = async () => {
        //console.log('Reload Paper');
        let ran =Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
        await this.setState({randomLoad: ran});
    };

    render() {

        const paper = this.state.paper;
        console.log(paper);
        const {pageNumber, numPages} = this.state;
        let newDate = new Date();

        let thisH = moment(newDate).format('hh');
        let thisM = moment(newDate).format('mm');
        let thisS = moment(newDate).format('ss');
        let logH = moment(paper.logTime).format('hh');
        let logM = moment(paper.logTime).format('mm');
        let logS = moment(paper.logTime).format('ss');

        let leftTime = thisH * 60 * 60 * 1000 + thisM * 60 * 1000 + thisS * 1000 - logH * 60 * 60 * 1000 - logM * 60 * 1000 - logS * 1000;


        const availableTime = Number(paper.remaningTime) * 60 * 1000 - leftTime;

        return (
            <div>
                <header>

                    <div className={"startpaper-header"}>
                        {
                            this.state.warningState === 1 ?
                                <div className={"warning-note"}>
                                    <span>
                                        Last Five Minutes.......
                                    </span>
                                </div>
                                :
                                null
                        }
                        <div className={"start-paper-titlebar"}>
                            <div>
                                <span className={"startPaper-timer"}>
                                    {
                                        this.state.mobileView === 0 ? <span>Time Remaining: </span> :
                                            <span>Time Left: </span>
                                    }

                                    <Timer
                                        initialTime={availableTime}
                                        direction="backward"
                                        checkpoints={[
                                            {
                                                time: 1 * 1000,
                                                callback: () => this.autoEndPaper(),
                                            },
                                        ]}
                                    >
                                        {() => (
                                            <React.Fragment>
                                                <Timer.Hours/> :
                                                <Timer.Minutes/>:
                                                <Timer.Seconds/>

                                            </React.Fragment>
                                        )}
                                    </Timer>
                                </span>
                            </div>

                            <div className={"complete-btnWrapper"}>
                                {
                                    this.state.mobileView === 0 ?
                                        <span className={"complete-btn"} onClick={this.submitPaper}>
                                            COMPLETE EXAM
                                        </span> :
                                        <span className={"complete-btn"} onClick={this.submitPaper}>
                                            COMPLETE
                                        </span>
                                }

                            </div>
                        </div>
                    </div>
                </header>

                <div>
                    <br/>
                    {
                        this.state.mobileView === 0 ?
                            <div>
                                <main ref="main" style={{display: this.state.toggleState === 0 ? null : "none"}}>
                                    <section className={"startPaper-section"}>
                                        <Container>
                                            <Row>
                                                {/*<Col md={12} lg={12}>*/}
                                           <Button  className={"log-btn "} style={{marginBottom:'10px'}} onClick={this.reloadPaper}>Reload Your Paper </Button>

                                                    <p style={{color:'green'}}>( Press this button if you cannot see the paper / ඔබට ප්‍රශ්න පත්‍රය දර්ශනය නොවේනම්, මෙම බොත්තම ඔබන්න. )</p>
                                                {/*</Col>*/}
                                            </Row>
                                            <div>
                                                <Row>
                                                    <Col lg="8" md="8" className={"pdf-wrapper"}>
                                                        {/*<Viewer*/}
                                                        {/*    fileUrl={this.state.paper.pdfUrl}*/}
                                                        {/*    // plugins={[*/}
                                                        {/*    //     zoomPluginInstance,*/}
                                                        {/*    // ]}*/}
                                                        {/*/>*/}

                                                            <iframe key={this.state.randomLoad} className="fullScreen"
                                                                    src={'https://docs.google.com/gview?embedded=true&url=' + this.state.paper.pdfUrl}/>

                                                        {/*<DocViewer*/}
                                                        {/*    documents={this.state.paper.pdfUrl}*/}
                                                        {/*/>*/}
                                                    </Col>

                                                    <Col md="4" lg="4" sm="6" className={"mt-3 answersheet-wrapper"}>
                                                        <h2>Instructions</h2>
                                                        <p className={"description-wrapper"}>{this.state.paper.description}</p>
                                                        {this.state.newResult.map((obj, questionIndex) =>
                                                            <div key={questionIndex}>
                                                                <Row>
                                                                    <Col lg="12">
                                                                        <p className={"question-number-wrapper"}>
                                                                            {
                                                                                questionIndex + 1 < 10 ?
                                                                                    <span
                                                                                        className={"question-number"}>0{questionIndex + 1}. </span> :
                                                                                    <span
                                                                                        className={"question-number"}>{questionIndex + 1}. </span>
                                                                            }
                                                                            {obj.answers.map((ans, answerIndex) =>

                                                                                <Button
                                                                                    className={"answer-btn "}
                                                                                    key={answerIndex}
                                                                                    checked={ans.condition}
                                                                                    style={{
                                                                                        background: ans.condition === true ? "#293D60 " : "#cbcdcf",
                                                                                        color: ans.condition === true ? "white " : "#293D60"
                                                                                    }}
                                                                                    onClick={() => this.answerChangeHandler(questionIndex, answerIndex)}
                                                                                > {answerIndex + 1} </Button>
                                                                            )
                                                                            }
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Container>
                                    </section>
                                </main>

                            </div>

                            :

                            <div>
                                <main ref="main">
                                    <section className={"startPaper-section"}>
                                        <Container>
                                            <Row>
                                            <Button  className={"log-btn "} style={{marginBottom:'12px',marginTop:'5px',marginLeft:'12px',marginRight:'12px'}} onClick={this.reloadPaper}>Reload </Button>

                                            <small style={{color:'green',marginTop:'15px'}}>(If you can't see the paper)</small>

                                            </Row>
                                            {/*<small style={{color:'green'}}>(ප්‍රශ්න පත්‍රය දර්ශනය නොවේ නම්, මෙම බොත්තම ඔබන්න.)</small>*/}
                                            <div style={{display: this.state.toggleState === 0 ? null : "none"}}>
                                                <Row>
                                                    <Col lg="8" className={"pdf-wrapper"}>
                                                        {/*<PDFViewer*/}
                                                        {/*    document={{*/}
                                                        {/*        url: this.state.paper.pdfUrl*/}
                                                        {/*    }}*/}
                                                        {/*/>*/}
                                                        {/*<Viewer*/}
                                                        {/*    fileUrl={this.state.paper.pdfUrl}*/}
                                                        {/*    // plugins={[*/}
                                                        {/*    //     zoomPluginInstance,*/}
                                                        {/*    // ]}*/}
                                                        {/*/>*/}
                                                        <iframe key={this.state.randomLoad} className="fullScreen2"
                                                                src={'https://docs.google.com/gview?embedded=true&url=' + this.state.paper.pdfUrl}/>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div style={{display: this.state.toggleState === 1 ? null : "none"}}>
                                                <Row>
                                                    <Col md="12" lg="12" sm="12"
                                                         className={"mt-3 answersheet-wrapper-mobi"}>
                                                        <h2>Instructions</h2>
                                                        <p className={"description-wrapper"}>{this.state.paper.description}</p>
                                                        {this.state.newResult.map((obj, questionIndex) =>
                                                            <div key={questionIndex}>
                                                                <Row>
                                                                    <Col lg="12">
                                                                        <p className={"question-number-wrapper"}>
                                                                            {
                                                                                questionIndex + 1 < 10 ?
                                                                                    <span
                                                                                        className={"question-number"}>0{questionIndex + 1}. </span> :
                                                                                    <span
                                                                                        className={"question-number"}>{questionIndex + 1}. </span>

                                                                            }
                                                                            {obj.answers.map((ans, answerIndex) =>
                                                                                <Button
                                                                                    className={"answer-btn-mobi "}
                                                                                    key={answerIndex}
                                                                                    checked={ans.condition}
                                                                                    style={{
                                                                                        background: ans.condition === true ? "#293D60 " : "#cbcdcf",
                                                                                        color: ans.condition === true ? "white " : "#293D60"
                                                                                    }}
                                                                                    onClick={() => this.answerChangeHandler(questionIndex, answerIndex)}
                                                                                > {answerIndex + 1} </Button>
                                                                            )
                                                                            }
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Container>
                                    </section>
                                </main>

                                <footer>
                                    <div className={"startpaper-footer"}>
                                        <div className={"toggle-btn"} style={{
                                            opacity: this.state.toggleState === 0 ? "1" : "0.5",
                                            borderRight: "1px solid white"
                                        }}>
                                            {/*<i class="icofont-paperclip"></i>*/}
                                            <br/>
                                            <span onClick={(e) => this.togglePaperAnswer(0)}>   Question Paper</span>
                                        </div>
                                        <div className={"toggle-btn"}
                                             style={{opacity: this.state.toggleState === 1 ? "1" : "0.5"}}>
                                            {/*<i class="icofont-tick-boxed"></i>*/}
                                            <br/>
                                            <span onClick={(e) => this.togglePaperAnswer(1)}>Answer Sheet</span></div>
                                    </div>
                                </footer>
                            </div>
                    }
                </div>
            </div>
        );
    }
}


export default StartPaper;
